import { useState, useRef, useEffect } from 'react';
import AgGrid from '../common/AgGrid';
import Icon from '../common/Icon';
import CommonModal from '../common/CommonModal';
import SuccessMessage from '../common/SuccessMessage';
import { GetListManagers, } from '../../services/accountService';
import { GetListSelectManagerment, GetListMaintainance, CreateListMaintainance, UpdateListMaintainance, DeleteListMaintainance } from '../../services/accountService';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AisScreenLoader } from '../../utils/AisScreenLoader';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';



const EditIconRenderer = (params) => {
  return (
    <div
      style={{ cursor: 'pointer', textAlign: 'center' }}
      onClick={(e) => params.onActionClick(e, params.data)}
    >
      <Icon name="action" size={16} width={3} />
    </div>
  );
};

const ListSelectManager = ({
  field,
  formData,
  onCustomChange,
  modalBodyRef
}) => {
  const { required = false } = field || {};
  const [selectOptions, setSelectOptions] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [dropdownDirection, setDropdownDirection] = useState('down');
  const [selectAll, setSelectAll] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedDropdownIds, setSelectedDropdownIds] = useState(new Set());
  const [searchQuery, setSearchQuery] = useState('');
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [itemToRemove, setItemToRemove] = useState(null);
  const [removeAllMode, setRemoveAllMode] = useState(false);
  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);
  useEffect(() => {
    const fetchSelectOptions = async () => {
      try {
        const data = await GetListSelectManagerment();

        const formatted = data.map(item => ({
          label: item.segmentMasterName,
          value: item.segmentMasterID
        }));

        setSelectOptions(formatted);
      } catch (err) {
        console.error('Error fetching select options:', err);
      }
    };

    fetchSelectOptions();
  }, []);

  useEffect(() => {
    if (formData?.listSelect && Array.isArray(formData.listSelect)) {
      const items = formData.listSelect.map(segment => ({
        id: segment.segmentMasterID,
        name: segment.segmentMasterName
      }));
      setSelectedItems(items);
    } else {
      setSelectedItems([]);
    }
    setSelectedDropdownIds(new Set());
    setSelectAll(false);
    setSearchQuery('');
  }, [formData?.listSelect]);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  const filteredOptions = (searchQuery.trim() === ''
    ? selectOptions
    : selectOptions.filter(opt =>
      opt.label.toLowerCase().includes(searchQuery.toLowerCase())
    )
  );
  const isNameTaken = (name) => {
    const normalized = name.trim().toLowerCase();
    if (!normalized) return true;

    const inSelectedItems = selectedItems.some(item => item.name.toLowerCase() === normalized);
    const inOptions = selectOptions.some(opt => opt.label.toLowerCase() === normalized);

    return inSelectedItems || inOptions;
  };

  const getSelectedDisplayText = () => {
    const totalSelected = selectedDropdownIds.size;
    if (totalSelected === 0) {
      return required ? 'Add or Select a Segment' : 'Add or Select a Segment';
    }

    if (totalSelected <= 2) {
      const selectedNames = [];
      selectedDropdownIds.forEach(id => {
        const opt = selectOptions.find(o => o.value === id);
        if (opt) {
          selectedNames.push(opt.label);
        }
      });
      return selectedNames.join(', ');
    }
    return `${totalSelected} segments selected`;
  };
  const handleAddItems = (e) => {
    e.preventDefault();
    const trimmedSearch = searchQuery.trim();
    const isNewSegmentCandidate =
      trimmedSearch !== '' && filteredOptions.length === 0 && !isNameTaken(trimmedSearch);

    if (selectedDropdownIds.size === 0 && !isNewSegmentCandidate) {
      toast.error('Please select or type at least one segment to add.');
      return;
    }

    const itemsToAdd = [];

    selectedDropdownIds.forEach(id => {
      const opt = selectOptions.find(o => o.value === id);

      if (opt) {
        const alreadyAdded = selectedItems.some(item =>
          item.id === opt.value ||
          item.name.toLowerCase() === opt.label.toLowerCase()
        );

        if (!alreadyAdded) {
          itemsToAdd.push({ id: opt.value, name: opt.label });
        }
      }
    });

    if (isNewSegmentCandidate) {
      itemsToAdd.push({
        id: `new-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
        name: trimmedSearch,
        isNew: true
      });
    }

    if (itemsToAdd.length > 0) {
      const updatedItems = [...selectedItems, ...itemsToAdd];

      setSelectedItems(updatedItems);
      setSelectedDropdownIds(new Set());
      setSelectAll(false);
      setSearchQuery('');
      setDropdownOpen(false);

      if (onCustomChange) {
        onCustomChange(
          'listSelect',
          updatedItems.map(item => ({
            segmentMasterID: item.isNew ? null : item.id,
            segmentMasterName: item.name
          }))
        );
      }
    } else {
      toast.error('Selected segment(s) already added.');
    }
  };

  const handleRemoveItem = (id) => {
    const updated = selectedItems.filter(item => item.id !== id);
    setSelectedItems(updated);

    if (onCustomChange) {
      onCustomChange(
        'listSelect',
        updated.map(item => ({
          segmentMasterID: item.id,
          segmentMasterName: item.name
        }))
      );
    }
  };
  const handleRemoveAllItems = () => {
    setSelectedItems([]);

    if (onCustomChange) {
      onCustomChange('listSelect', []);
    }
  };

  const handleDropdownCheckboxChange = (id, isChecked) => {
    const newSelectedIds = new Set(selectedDropdownIds);

    if (isChecked) {
      newSelectedIds.add(id);
    } else {
      newSelectedIds.delete(id);
      setSelectAll(false);
    }

    setSelectedDropdownIds(newSelectedIds);
  };

  // Handle "(All)" select-all checkbox change in dropdown
  const handleSelectAllChange = (isChecked) => {
    setSelectAll(isChecked);

    if (isChecked) {
      const allIds = new Set();
      selectOptions.forEach(opt => {
        const alreadyAdded = selectedItems.some(item => item.id === opt.value);
        if (!alreadyAdded) {
          allIds.add(opt.value);
        }
      });
      setSelectedDropdownIds(allIds);
    } else {
      setSelectedDropdownIds(new Set());
    }
  };

  const isAddButtonDisabled = selectedDropdownIds.size === 0
    && !(searchQuery.trim() !== '' && filteredOptions.length === 0);

  // Opens the shared confirm modal in "Remove All" mode
  const handleRemoveAllClick = () => {
    if (selectedItems.length === 0) return;
    setRemoveAllMode(true);
    setShowConfirmModal(true);
  };

  const handleConfirmRemove = () => {
    if (removeAllMode) {
      handleRemoveAllItems();
    } else if (itemToRemove) {
      handleRemoveItem(itemToRemove.id);
    }
    setShowConfirmModal(false);
    setItemToRemove(null);
    setRemoveAllMode(false);
  };

  const handleCancelRemove = () => {
    setShowConfirmModal(false);
    setItemToRemove(null);
    setRemoveAllMode(false);
  };

  const RemoveIconRenderer = (params) => {
    const handleRemoveClick = () => {
      setItemToRemove(params.data);
      setRemoveAllMode(false);
      setShowConfirmModal(true);
    };

    return (
      <div
        className='remove-button-container'
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '100%',
          height: '100%'
        }}
      >
        <button
          onClick={handleRemoveClick}
          className='remove-btn'
          type="button"
          style={{
            padding: '5px 14px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '12px',
            fontWeight: '500',
            lineHeight: '1.4',
            whiteSpace: 'nowrap'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = '#c82333';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = '#dc3545';
          }}
        >
          Remove
        </button>
      </div>
    );
  };


  const GRID_ROW_HEIGHT = 50;
  const GRID_HEADER_HEIGHT = 48;
  const GRID_MAX_HEIGHT = 300;
  const computedGridHeight = Math.min(
    GRID_MAX_HEIGHT,
    GRID_HEADER_HEIGHT + (selectedItems.length * GRID_ROW_HEIGHT) + 2
  );

  const selectedItemsColumnDefs = [
    {
      field: 'name',
      headerName: 'Select Name',
      filter: false,
      sortable: false,
      flex: 1,
      minWidth: 220,
      tooltipField: 'name',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
      }
    },
    {
      field: 'remove',
      headerName: 'Remove',
      filter: false,
      sortable: false,
      width: 120,
      minWidth: 120,
      maxWidth: 120,
      resizable: false,
      suppressSizeToFit: true,
      suppressHeaderMenuButton: true,
      cellRenderer: RemoveIconRenderer,
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0'
      }
    }
  ];
  const getDropdownBorderStyle = () => {
    if (field?.error && field?.touched) {
      return '1px solid #dc3545';
    }
    return '1px solid #ced4da';
  };

  const DROPDOWN_MAX_HEIGHT = 200;
  const DROPDOWN_MIN_HEIGHT = 140;
  const VIEWPORT_MARGIN = 12;

  const [dropdownMaxHeight, setDropdownMaxHeight] = useState(DROPDOWN_MAX_HEIGHT);

  const checkDropdownDirection = () => {
    if (!buttonRef.current || !modalBodyRef?.current) return;

    const buttonRect = buttonRef.current.getBoundingClientRect();
    const modalRect = modalBodyRef.current.getBoundingClientRect();

    const spaceBelow = modalRect.bottom - buttonRect.bottom - VIEWPORT_MARGIN;
    const spaceAbove = buttonRect.top - modalRect.top - VIEWPORT_MARGIN;
    if (spaceBelow >= DROPDOWN_MAX_HEIGHT) {
      setDropdownDirection('down');
      setDropdownMaxHeight(DROPDOWN_MAX_HEIGHT);
    } else if (spaceAbove > spaceBelow) {
      setDropdownDirection('up');
      setDropdownMaxHeight(Math.max(DROPDOWN_MIN_HEIGHT, Math.min(DROPDOWN_MAX_HEIGHT, spaceAbove)));
    } else {
      setDropdownDirection('down');
      setDropdownMaxHeight(Math.max(DROPDOWN_MIN_HEIGHT, Math.min(DROPDOWN_MAX_HEIGHT, spaceBelow)));
    }
  };

  useEffect(() => {
    const handleResize = () => {
      if (dropdownOpen) checkDropdownDirection();
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [dropdownOpen]);

  return (
    <>
      <div style={{ borderTop: '1px solid #e0e0e0', paddingTop: '16px', marginTop: '16px' }}>
        <label className="form-label">
          List Select Management
          {required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
        </label>

        <div style={{ display: 'flex', gap: '16px', alignItems: 'flex-start' }} ref={dropdownRef}>
          <div style={{ flex: 0.8, width: '60%' }}>
            <div style={{ position: 'relative' }}>
              <button
                ref={buttonRef}
                type="button"
                onClick={() => {
                  if (!dropdownOpen) {
                    checkDropdownDirection();
                  }
                  setDropdownOpen(prev => !prev);
                }}
                className='user-type-dropdown'
                style={{
                  width: '100%',
                  textAlign: 'left',
                  padding: '8px 12px',
                  border: getDropdownBorderStyle(),
                  borderRadius: '4px',
                  backgroundColor: 'white',
                  cursor: 'pointer',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  fontSize: '14px',
                  outline: 'none'
                }}
              >
                <span style={{
                  color: selectedDropdownIds.size > 0 ? '#333' : '#6c757d',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }}>
                  {getSelectedDisplayText()}
                </span>
                <span
                  style={{
                    fontSize: '12px',
                    color: '#6c757d',
                    transform: dropdownOpen && dropdownDirection === 'up'
                      ? 'rotate(180deg)'
                      : 'rotate(0deg)',
                    transition: 'transform 0.2s ease'
                  }}
                >
                  ▼
                </span>
              </button>
              {dropdownOpen && selectOptions.length > 0 && (
                <div style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  backgroundColor: 'white',
                  border: '1px solid #ced4da',
                  borderRadius: '4px',
                  boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                  zIndex: 1000,
                  maxHeight: `${dropdownMaxHeight}px`,
                  overflowY: 'auto',
                  overflowX: 'hidden',
                  top: dropdownDirection === 'down' ? '100%' : 'auto',
                  bottom: dropdownDirection === 'up' ? '100%' : 'auto',
                  marginTop: dropdownDirection === 'down' ? '2px' : '0',
                  marginBottom: dropdownDirection === 'up' ? '2px' : '0',
                }}>
                  {/* ✅ SEARCH INPUT */}
                  <div style={{
                    padding: '8px 12px',
                    borderBottom: '1px solid #eee',
                    backgroundColor: '#f8f9fa',
                    position: 'sticky',
                    top: 0,
                    zIndex: 1001
                  }}>
                    <input
                      type="text"
                      placeholder="Search or type to add a new segment..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      autoFocus
                      style={{
                        width: '100%',
                        padding: '6px 8px',
                        border: '1px solid #ced4da',
                        borderRadius: '3px',
                        fontSize: '13px',
                        outline: 'none',
                        fontFamily: 'inherit'
                      }}
                    />
                  </div>
                  {filteredOptions.length > 0 && (
                    <div style={{
                      padding: '8px 12px',
                      borderBottom: '1px solid #eee',
                      backgroundColor: '#f8f9fa',
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                      position: 'sticky',
                      top: '48px',
                      zIndex: 1000
                    }}>
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={(e) => handleSelectAllChange(e.target.checked)}
                        style={{ cursor: 'pointer' }}
                      />
                      <span style={{ fontWeight: 'bold', fontSize: '14px' }}>(All)</span>
                    </div>
                  )}

                  {filteredOptions.length > 0 ? (
                    filteredOptions.map((opt) => {
                      const alreadyAdded = selectedItems.some(item => item.id === opt.value);
                      const isChecked = selectedDropdownIds.has(opt.value) || alreadyAdded;

                      return (
                        <div
                          key={opt.value}
                          style={{
                            padding: '8px 12px',
                            borderBottom: '1px solid #f5f5f5',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            minWidth: 0,
                            cursor: alreadyAdded ? 'not-allowed' : 'pointer',
                            backgroundColor: isChecked ? '#f0f8ff' : 'white',
                            opacity: alreadyAdded ? 0.5 : 1,
                            transition: 'background-color 0.2s'
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            if (alreadyAdded) return;
                            handleDropdownCheckboxChange(opt.value, !selectedDropdownIds.has(opt.value));
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={isChecked}
                            disabled={alreadyAdded}
                            onChange={(e) => {
                              e.stopPropagation();
                              handleDropdownCheckboxChange(opt.value, e.target.checked);
                            }}
                            style={{ cursor: alreadyAdded ? 'not-allowed' : 'pointer' }}
                          />
                          <span
                            title={opt.label}
                            style={{
                              fontSize: '14px',
                              flex: 1,
                              minWidth: 0,
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              color: isChecked ? '#0D6EFD' : '#333'
                            }}>
                            {opt.label}
                          </span>
                        </div>
                      );
                    })
                  ) : (
                    <div style={{
                      padding: '12px',
                      textAlign: 'center',
                      color: '#6c757d',
                      fontSize: '13px',
                    }}>
                      No segments found {searchQuery}.
                      <br />Click <span style={{ fontWeight: "bold", color: "black" }}>Add Select</span> to add new segment.
                    </div>
                  )}
                </div>
              )}
            </div>

            {selectedDropdownIds.size > 0 && (
              <div style={{
                marginTop: '4px',
                fontSize: '12px',
                color: '#0D6EFD',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <span>{selectedDropdownIds.size} selected</span>
                <button
                  onClick={() => {
                    setSelectedDropdownIds(new Set());
                    setSelectAll(false);
                  }}
                  style={{
                    background: 'none',
                    border: 'none',
                    color: '#dc3545',
                    fontSize: '11px',
                    cursor: 'pointer',
                    textDecoration: 'underline',
                    padding: 0
                  }}
                  type="button"
                >
                  Clear
                </button>
              </div>
            )}
          </div>

          <div style={{ flex: 0.25, width: '30%', marginBottom: '8px' }}>
            <button
              onClick={handleAddItems}
              className='add-client-btn-user-modal'
              type="button"
              disabled={isAddButtonDisabled}
            >
              Add Select{selectedDropdownIds.size > 1 ? 's' : ''}
            </button>
          </div>
        </div>

        {selectedItems.length > 0 && (
          <div style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '16px',
            marginBottom: '4px'
          }}>
            <span
              onClick={handleRemoveAllClick}
              style={{
                fontSize: '12px',
                color: '#dc3545',
                cursor: 'pointer',
                textDecoration: 'underline',
                fontWeight: '500'
              }}
            >
              Remove All
            </span>
          </div>
        )}

        {selectedItems.length > 0 ? (
          <div
            className='ag-grid-table-structure'
            style={{
              height: `${computedGridHeight}px`,
              width: '100%',
              position: 'relative',
              border: '1px solid #e0e0e0',
              borderRadius: '8px',
              overflow: 'hidden',
              marginTop: '8px'
            }}
          >
            <AgGrid
              rowData={selectedItems}
              columnDefs={selectedItemsColumnDefs}
              enableSearch={false}
              enableSorting={false}
              enableFilter={false}
              pagination={false}
              height={`${computedGridHeight}px`}
              hideSelectAll={true}
              hidePivotMode={true}
              hideExcelExport={true}
              hideExportButton={true}
              hideColumnMenu={true}
              hideSideBar={true}
              gridOptions={{
                defaultColDef: {
                  resizable: false,
                  minWidth: 100,
                  suppressHeaderMenuButton: true,
                },
                headerHeight: 44,
                rowHeight: 48,
                domLayout: 'normal',
                suppressHorizontalScroll: true,
              }}

              onGridReady={(params) => {
                params.api.sizeColumnsToFit();
                const gridEl = params.api.getGridId
                  ? document.querySelector(`[row-id]`)?.closest('.ag-root-wrapper')
                  : null;
                const header = (gridEl || document).querySelector('.ag-header');
                if (header) {
                  header.style.backgroundColor = '#f5f5f5';
                }
                const bodyViewport = (gridEl || document).querySelector('.ag-body-viewport');
                if (bodyViewport) {
                  bodyViewport.style.overflowY = 'auto';
                  bodyViewport.style.overflowX = 'hidden';
                }
              }}
            />
          </div>
        ) : (
          <div style={{
            textAlign: 'start',
            padding: '20px',
            color: '#6c757d',
            fontWeight: '400',
            backgroundColor: '#f8f9fa',
            borderRadius: '4px',
            marginTop: '16px',
            fontSize: '14px'
          }}>
            No items selected yet
          </div>
        )}
      </div>
      {showConfirmModal && (removeAllMode || itemToRemove) && (
        <>
          <div className="modal-overlay" />
          <div className="message-modal-warning">
            <div className="message-content-wrapper-remove">
              <Icon name="warning-icon" size={32} />
              <div className="message-title-remove">
                {removeAllMode ? 'Remove all selects from list?' : 'Remove select from list?'}
              </div>
              <span>
                {removeAllMode
                  ? 'All selects will no longer be assigned to this list.'
                  : 'This select will no longer be assigned to this list.'}
              </span>
            </div>

            <div className='remove-btn-container'>
              <button
                onClick={handleCancelRemove}
                className='discard-changes-btn'
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmRemove}
                className='remove-btn-client'
              >
                {removeAllMode ? 'Remove All' : 'Remove Select'}
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

const ListNameMaintenance = () => {
  const [searchText, setSearchText] = useState('');
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [deleteInProgress, setDeleteInProgress] = useState(false);
  const [selectedCostsToDelete, setSelectedCostsToDelete] = useState([]);
  const [successMessage, setSuccessMessage] = useState('');
  // 🔽 NEW: separate state for warning-style popups (e.g. duplicate list name)
  const [errorPopupMessage, setErrorPopupMessage] = useState('');
  const [modalMode, setModalMode] = useState('edit');
  const [isLoading, setIsLoading] = useState(true);

  const [rowData, setRowData] = useState([]);

  const agGridRef = useRef(null);
  const gridApiRef = useRef(null);
  const [showExportMenu, setShowExportMenu] = useState(false);
  const exportMenuRef = useRef(null);

  useEffect(() => {
    const fetchListData = async () => {
      setIsLoading(true);
      try {
        const data = await GetListMaintainance();

        const formatted = data.map(item => ({
          listMasterID: item.listMasterID,
          listName: item.listMasterName,
          listManager: item.listManagerName || '',
          listManagerID: item.listManagerID,
          segments: item.segments || []
        }));

        setRowData(formatted);
      } catch (err) {
        console.error('Error fetching list data:', err);
      }
      finally {
        setIsLoading(false);
      }

    };

    fetchListData();
  }, []);


  const [managerOptions, setManagerOptions] = useState([]);
  useEffect(() => {
    const fetchManagers = async () => {
      try {
        const data = await GetListManagers();

        const formatted = data.map(item => ({
          label: item.listManagerName,
          value: item.listManagerID
        }));

        setManagerOptions(formatted);
      } catch (err) {
        console.error('Error fetching managers:', err);
      }
    };

    fetchManagers();
  }, []);


  const [actionMenu, setActionMenu] = useState({
    isOpen: false,
    x: 0,
    y: 0,
    data: null
  });

  const menuRef = useRef(null);


  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);


  const [formErrors, setFormErrors] = useState({});


  const [touchedFields, setTouchedFields] = useState({});


  const [selectedItems, setSelectedItems] = useState([]);
  const [currentSelect, setCurrentSelect] = useState('');


  const handleActionClick = (e, data) => {
    e.stopPropagation();

    const rect = e.currentTarget.getBoundingClientRect();

    setActionMenu({
      isOpen: true,
      x: rect.left,
      y: rect.bottom,
      data
    });
  };


  useEffect(() => {
    const handleClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        setActionMenu((prev) => ({ ...prev, isOpen: false }));
      }
    };

    document.addEventListener('click', handleClick);
    return () => document.removeEventListener('click', handleClick);
  }, []);


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (exportMenuRef.current && !exportMenuRef.current.contains(event.target)) {
        setShowExportMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const EXPORT_COLUMNS = [
    { field: 'listName', headerName: 'List Name' },
    { field: 'listManager', headerName: 'List Manager' },
    { field: 'segments', headerName: 'Segments' },
  ];

  const formatValueForField = (field, row) => {
    if (field === 'segments') {
      const segs = row?.segments;
      if (Array.isArray(segs) && segs.length > 0) {
        return segs
          .map(s => s?.segmentMasterName || s?.name || '')
          .filter(Boolean)
          .join(', ');
      }
      return '';
    }
    const value = row?.[field];
    if (value === null || value === undefined) return '';
    return String(value);
  };

  const getExportColumns = () => EXPORT_COLUMNS;

  const getExportRows = () => {
    const api = gridApiRef.current;
    const allRows = rowData || [];


    let visible = null;
    if (api && typeof api.forEachNodeAfterFilter === 'function') {
      const rows = [];
      api.forEachNodeAfterFilter((node) => {
        if (node.data) rows.push(node.data);
      });
      visible = rows;
    }

    const isFiltered = visible !== null && visible.length !== allRows.length;

    // Checked rows.
    let selected = [];
    if (api && typeof api.getSelectedRows === 'function') {
      selected = api.getSelectedRows().filter(Boolean);
    }

    if (selected.length > 0) {
      if (visible !== null) {
        const visibleSet = new Set(visible);
        const checkedVisible = selected.filter((r) => visibleSet.has(r));
        if (checkedVisible.length > 0) {
          return { rows: checkedVisible, scope: 'selected' };
        }
      } else {
        return { rows: selected, scope: 'selected' };
      }
    }

    if (isFiltered) {
      return { rows: visible, scope: 'filtered' };
    }

    return {
      rows: visible !== null ? visible : allRows,
      scope: 'all',
    };
  };

  const exportToExcel = () => {
    const { rows: exportRows } = getExportRows();

    if (!exportRows || exportRows.length === 0) {
      toast.error('No data to export');
      setShowExportMenu(false);
      return;
    }

    try {
      const exportColumns = getExportColumns();

      const exportData = exportRows.map((row) => {
        const obj = {};
        exportColumns.forEach(({ field, headerName }) => {
          obj[headerName] = formatValueForField(field, row);
        });
        return obj;
      });

      const ws = XLSX.utils.json_to_sheet(exportData);

      const colWidths = [];
      Object.keys(exportData[0] || {}).forEach((key, index) => {
        const maxLength = Math.max(
          key.length,
          ...exportData.map((row) => {
            const value = row[key];
            return value ? String(value).length : 0;
          })
        );
        colWidths[index] = { wch: Math.min(maxLength + 2, 50) };
      });
      ws['!cols'] = colWidths;

      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'List Maintenance');

      const currentDate = new Date();
      const dateStr = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
      const fileName = `List_Maintenance_${dateStr}.xlsx`;

      XLSX.writeFile(wb, fileName);

      setSuccessMessage('Export completed successfully!');
      setShowExportMenu(false);
    } catch (error) {
      console.error('Error exporting to Excel:', error);
      toast.error('Error exporting data to Excel');
      setShowExportMenu(false);
    }
  };

  const printToPDF = () => {
    const { rows: exportRows, scope } = getExportRows();

    if (!exportRows || exportRows.length === 0) {
      toast.error('No data to export');
      setShowExportMenu(false);
      return;
    }

    try {
      const exportColumns = getExportColumns();

      const doc = new jsPDF({
        orientation: 'landscape',
        unit: 'pt',
        format: 'a4',
      });

      const pageWidth = doc.internal.pageSize.getWidth();
      const marginX = 20;
      const cardX = marginX;
      const cardY = 20;
      const cardWidth = pageWidth - marginX * 2;
      const headerBarHeight = 50;


      const BLUE_DARK = [30, 75, 120];
      const BLUE_DEEP = [22, 58, 95];


      doc.setFillColor(...BLUE_DARK);
      doc.rect(cardX, cardY, cardWidth, headerBarHeight, 'F');

      const logoW = 90;
      doc.setFillColor(...BLUE_DEEP);
      doc.rect(cardX, cardY, logoW, headerBarHeight, 'F');

      doc.setTextColor(255, 255, 255);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(13);
      doc.text('Rockwell', cardX + logoW / 2, cardY + headerBarHeight / 2 - 2, {
        align: 'center',
      });
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(6);
      doc.setTextColor(180, 200, 220);
      doc.text('— SOLUTIONS —', cardX + logoW / 2, cardY + headerBarHeight / 2 + 9, {
        align: 'center',
      });

      const cardCenterX = cardX + cardWidth / 2;
      doc.setTextColor(255, 255, 255);
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);
      doc.text('LIST MAINTENANCE', cardCenterX, cardY + headerBarHeight / 2 + 2, { align: 'center' });

      const currentDate = new Date();
      const reportDateStr = `${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${currentDate.getDate().toString().padStart(2, '0')}/${(currentDate.getFullYear() % 100).toString().padStart(2, '0')}`;

      const metaX = cardX + cardWidth - 14;
      const metaCenterY = cardY + headerBarHeight / 2;

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(13);
      doc.setTextColor(255, 255, 255);
      doc.text('Report', metaX, metaCenterY - 2, { align: 'right' });

      doc.setFont('helvetica', 'normal');
      doc.setFontSize(7);
      doc.setTextColor(180, 200, 220);
      doc.text(reportDateStr, metaX, metaCenterY + 10, { align: 'right' });

      const scopeLabel =
        scope === 'selected' ? 'Selected'
          : scope === 'filtered' ? 'Filtered'
            : 'All';


      const tableStartY = cardY + headerBarHeight + 20;

      const head = [exportColumns.map((c) => c.headerName)];
      const body = exportRows.map((row) =>
        exportColumns.map(({ field }) => formatValueForField(field, row))
      );

      autoTable(doc, {
        head,
        body,
        startY: tableStartY,
        margin: { left: marginX, right: marginX },
        styles: {
          fontSize: 8,
          cellPadding: 4,
          overflow: 'linebreak',
          valign: 'middle',
        },
        headStyles: {
          fillColor: [46, 111, 159],
          textColor: [255, 255, 255],
          fontStyle: 'bold',
          fontSize: 8,
        },
        alternateRowStyles: {
          fillColor: [250, 250, 250],
        },
        didDrawPage: (data) => {
          const pageCount = doc.internal.getNumberOfPages();
          const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
          const pageHeight = doc.internal.pageSize.getHeight();
          doc.setFontSize(8);
          doc.setTextColor(120, 120, 120);
          doc.text(
            `Page ${pageCurrent} of ${pageCount}`,
            pageWidth - marginX,
            pageHeight - 10,
            { align: 'right' }
          );
          doc.text(
            `${scopeLabel} Records: ${exportRows.length}`,
            marginX,
            pageHeight - 10,
            { align: 'left' }
          );
        },
      });

      const fileNameDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;
      doc.save(`List_Maintenance_${fileNameDate}.pdf`);

      setSuccessMessage('Export completed successfully!');
      setShowExportMenu(false);
    } catch (error) {
      console.error('Error exporting to PDF:', error);
      toast.error('Error exporting data to PDF');
      setShowExportMenu(false);
    }
  };


  const handleEdit = () => {
    const editData = {
      ...actionMenu.data,
      listManager: actionMenu.data.listManagerID,
      listSelect: actionMenu.data.segments || []
    };

    setSelectedRow(editData);
    setFormErrors({});
    setTouchedFields({});
    setModalMode('edit');
    setIsModalOpen(true);
    setActionMenu((prev) => ({ ...prev, isOpen: false }));
  };


  const handleAddList = () => {
    if (managerOptions.length === 0) {
      alert("Loading managers... Please wait a moment and try again");
      return;
    }

    setSelectedRow(null);
    setFormErrors({});
    setTouchedFields({});
    setModalMode('add');
    setIsModalOpen(true);
  };


  const handleDelete = () => {
    setSelectedCostsToDelete([actionMenu.data]);
    setShowDeleteConfirm(true);
    setActionMenu((prev) => ({ ...prev, isOpen: false }));
  };

  const handleCancelDelete = () => {
    setShowDeleteConfirm(false);
    setSelectedCostsToDelete([]);
  };

  const handleConfirmDelete = async () => {
    setDeleteInProgress(true);

    try {
      const listToDelete = selectedCostsToDelete[0];
      if (!listToDelete?.listMasterID) {
        alert("List ID is missing!");
        setDeleteInProgress(false);
        return;
      }

      await DeleteListMaintainance(listToDelete.listMasterID);

      setRowData(prev =>
        prev.filter(item => item.listMasterID !== listToDelete.listMasterID)
      );

      setSuccessMessage(
        `${selectedCostsToDelete.length} item(s) deleted successfully`
      );

      setShowDeleteConfirm(false);
      setSelectedCostsToDelete([]);
    } catch (err) {
      // 🔽 UPDATED: delete failures (e.g. "List is in use against mail codes")
      // now surface in the warning popup instead of a toast. This backend
      // response uses the ProblemDetails `detail` shape, which
      // extractApiErrorMessage already handles.
      const errorDetail = extractApiErrorMessage(err) || 'Failed to delete list.';

      setShowDeleteConfirm(false);
      setSelectedCostsToDelete([]);

      setErrorPopupMessage(errorDetail);

    } finally {
      setDeleteInProgress(false);
    }
  };

  const validators = {
    listName: (value) => {
      if (value === undefined || value === null || value === '') {
        return 'List Name is required.';
      }
      if (typeof value === 'string' && value.trim().length === 0) {
        return 'List Name cannot be only whitespace.';
      }
      if (value.length > 264) {
        return 'List Name cannot exceed 264 characters.';
      }
      return null;
    },


    listManager: (value) => {
      // List Manager is OPTIONAL (both add & edit). Empty is always valid.
      if (value === undefined || value === null || value === '') {
        return null;
      }

      const managerId = Number(value);

      // Only guard against a genuinely non-numeric value. We DON'T block on
      // "not in managerOptions" — this is a controlled dropdown (user can only
      // pick valid options), and in edit mode the pre-loaded managerID may not
      // be present in the current options list (e.g. deactivated manager or a
      // number/string type mismatch), which was causing a false validation
      // error on save even though the field is optional.
      if (Number.isNaN(managerId)) {
        return 'Invalid List Manager.';
      }

      return null;
    },


    listSelect: (value) => {
      if (!Array.isArray(value) || value.length === 0) {
        return null;
      }


      const seen = new Set();
      const duplicates = [];

      value.forEach(item => {
        const name = (item.segmentMasterName || '').trim().toLowerCase();
        if (name) {
          if (seen.has(name)) {
            duplicates.push(item.segmentMasterName);
          }
          seen.add(name);
        }
      });

      if (duplicates.length > 0) {
        return `Duplicate segments in request: ${[...new Set(duplicates)].join(', ')}`;
      }

      return null;
    }
  };


  const isDuplicateListName = (name, currentListMasterID) => {
    const target = (name || '').trim().toLowerCase();
    return rowData.some(item =>
      item.listName?.trim().toLowerCase() === target &&
      item.listMasterID !== currentListMasterID
    );
  };

  // 🔽 NEW: parses backend ValidationProblemDetails shape
  // {
  //   "errors": { "ListMasterName": ["A list with this name already exists."] }
  // }
  // Falls back gracefully to `.detail` or `err.message` for any other error shape.
  const extractApiErrorMessage = (err) => {
    const data = err?.response?.data || err?.data;

    if (data?.errors && typeof data.errors === 'object') {
      const messages = Object.values(data.errors).flat().filter(Boolean);
      if (messages.length > 0) return messages.join(' ');
    }

    if (data?.detail) return data.detail;
    if (err?.message) return err.message;

    return null;
  };

  // 🔽 NEW: true when the response is an ASP.NET ValidationProblemDetails,
  // i.e. it carries a field->messages `errors` object. Covers duplicate list
  // name (ListMasterName), segment-in-use-by-mail-code (Segments), and any
  // future field-level validation the backend adds. These all get shown in the
  // warning popup rather than a toast.
  const isValidationApiError = (err) => {
    const data = err?.response?.data || err?.data;
    const errorsObj = data?.errors;
    return !!errorsObj && typeof errorsObj === 'object' && Object.keys(errorsObj).length > 0;
  };


  const validateField = (fieldName, value) => {

    if (validators[fieldName]) {
      const error = validators[fieldName](value);
      if (error) return error;
    }


    if (fieldName === 'listName') {
      const currentId = modalMode === 'edit' ? selectedRow?.listMasterID : 0;

    }

    return null;
  };

  const handleFieldChange = (fieldName, value) => {
    setTouchedFields(prev => ({ ...prev, [fieldName]: true }));

    const error = validateField(fieldName, value);

    setFormErrors(prev => {
      const next = { ...prev };
      if (error) {
        next[fieldName] = error;
      } else {
        delete next[fieldName];
      }
      return next;
    });
  };

  const handleFieldBlur = (fieldName, value) => {
    setTouchedFields(prev => ({ ...prev, [fieldName]: true }));

    const error = validateField(fieldName, value);

    setFormErrors(prev => {
      const next = { ...prev };
      if (error) {
        next[fieldName] = error;
      } else {
        delete next[fieldName];
      }
      return next;
    });
  };
  const validateForm = (formData) => {
    const errors = {};

    Object.keys(validators).forEach(fieldName => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
        errors[fieldName] = error;
      }
    });

    return errors;
  };

  const handleSave = async (formData) => {
    const errors = validateForm(formData);
    setFormErrors(errors);
    setTouchedFields({ listName: true, listManager: true, listSelect: true });

    if (Object.keys(errors).length > 0) {
      Object.values(errors).forEach(msg => toast.error(msg));
      return; // stop save
    }


    if (modalMode === 'add' && isDuplicateListName(formData.listName, 0)) {
      setErrorPopupMessage('A list with this name already exists.');
      return; // stop save
    }

    try {

      const managerId = formData.listManager ? Number(formData.listManager) : null;

      if (modalMode === 'add') {
        const payload = {
          listMasterID: 0,  // New list
          listMasterName: formData.listName.trim(),
          listManagerID: managerId,
          segments: Array.isArray(formData.listSelect)
            ? formData.listSelect.map(item => item.segmentMasterName)
            : []
        };

        const response = await CreateListMaintainance(payload);

        const newList = {
          listMasterID: response.listMasterID,
          listName: response.listMasterName,
          listManager: response.listManagerName,
          listManagerID: response.listManagerID,
          segments: response.segments || []
        };

        setRowData(prev => [...prev, newList]);
        setSuccessMessage('List added successfully');

      } else if (modalMode === 'edit') {
        if (!selectedRow?.listMasterID) {
          alert("List ID is missing!");
          return;
        }

        const payload = {
          listMasterID: selectedRow.listMasterID,
          listMasterName: formData.listName.trim(),
          listManagerID: managerId,
          segments: Array.isArray(formData.listSelect)
            ? formData.listSelect.map(item => item.segmentMasterName)
            : []
        };

        const response = await UpdateListMaintainance(payload);
        setRowData(prev =>
          prev.map(item =>
            item.listMasterID === response.listMasterID
              ? {
                listMasterID: response.listMasterID,
                listName: response.listMasterName,
                listManager: response.listManagerName,
                listManagerID: response.listManagerID,
                segments: response.segments || []
              }
              : item
          )
        );

        setSuccessMessage('List updated successfully');
      }

      setIsModalOpen(false);
      setSelectedRow(null);
      setFormErrors({});
      setTouchedFields({});

    } catch (err) {
      // 🔽 UPDATED: route ALL backend field-validation errors (duplicate list
      // name, segment-in-use-by-mail-code, etc.) to the warning popup.
      // Anything else (network, 500, unknown) still falls back to a toast.
      const errorDetail = extractApiErrorMessage(err) || 'Error saving list.';

      if (isValidationApiError(err)) {
        setErrorPopupMessage(errorDetail);
      } else {
        toast.error(errorDetail);
      }
    }
  };

  const fields = [
    {
      name: 'listName',
      label: 'List Name',
      type: 'text',
      required: true,
      placeholder: 'List Name',
      minWidth: 300,
      maxLength: 264,
      validation: validators.listName,
    },
    {
      name: 'listManager',
      label: 'List Manager',
      type: 'select',
      required: false,
      options: managerOptions,
      validation: validators.listManager,
    },
    {
      name: 'listSelect',
      label: 'List Select',
      component: ListSelectManager,
      validation: validators.listSelect,
    }
  ];

  const columnDefs = [
    {
      field: 'listName',
      headerName: 'List Name',
      flex: 1,
      filter: 'agTextColumnFilter',
      minWidth: 400,
      tooltipField: 'listName',
      cellClass: 'truncate-cell'
    },

    { field: 'listManager', headerName: 'List Manager', flex: 1, filter: 'agTextColumnFilter', },
    {
      headerName: 'Action',
      field: 'action',
      filter: false, sortable: false,
      cellRenderer: EditIconRenderer,
      suppressHeaderMenuButton: true,
      width: 100,
      cellStyle: { fontWeight: 'normal' },
      cellRendererParams: {
        onActionClick: handleActionClick
      }
    }
  ];


  return (
    <>
      <ToastContainer />
      <div>

        <div style={{ display: 'flex', gap: '12px', marginBottom: '16px', alignItems: 'center', position: 'absolute', zIndex: 10 }}>
          <button
            className='add-user-button'
            onClick={handleAddList}
          >
            + Add List
          </button>

          <div style={{ position: 'relative' }} ref={exportMenuRef}>
            <button
              className="job-details-menu-button"
              onClick={() => setShowExportMenu((prev) => !prev)}

              aria-label="Export options"
            >
              <span className="menu-dot" style={{ display: 'inline-block', width: '4px', height: '4px', borderRadius: '50%', background: '#333', margin: '0 1px' }}></span>
              <span className="menu-dot" style={{ display: 'inline-block', width: '4px', height: '4px', borderRadius: '50%', background: '#333', margin: '0 1px' }}></span>
              <span className="menu-dot" style={{ display: 'inline-block', width: '4px', height: '4px', borderRadius: '50%', background: '#333', margin: '0 1px' }}></span>
            </button>

            {showExportMenu && (
              <div style={{
                position: 'absolute', top: '100%', left: 0, marginTop: '8px',
                backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '4px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)', zIndex: 1000,
                minWidth: '180px', overflow: 'hidden'
              }}>
                {/* Export to Excel */}
                <div
                  onClick={exportToExcel}
                  style={{
                    padding: '10px 16px', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', gap: '8px',
                    transition: 'background-color 0.2s', fontSize: '14px', color: '#333',
                    borderBottom: '1px solid #f0f0f0'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f5f5f5'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                    <line x1="8" y1="13" x2="16" y2="13" />
                    <line x1="8" y1="17" x2="16" y2="17" />
                    <polyline points="10 9 9 9 8 9" />
                  </svg>
                  Export to Excel
                </div>

                {/* Print To Pdf */}
                <div
                  onClick={printToPDF}
                  style={{
                    padding: '10px 16px', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', gap: '8px',
                    transition: 'background-color 0.2s', fontSize: '14px', color: '#333'
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f5f5f5'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="6 9 6 2 18 2 18 9" />
                    <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2" />
                    <rect x="6" y="14" width="12" height="8" />
                  </svg>
                  Print To PDF
                </div>
              </div>
            )}
          </div>
        </div>


        {isLoading ? (
          <AisScreenLoader />
        ) : (
          <AgGrid
            ref={agGridRef}
            enableSearch
            searchPlaceholder="Search Lists..."
            pagination
            hideSideBar={true}
            height="500px"
            quickFilterText={searchText}
            onQuickFilterChange={setSearchText}
            rowData={rowData}
            columnDefs={columnDefs}
            onGridReady={(params) => { gridApiRef.current = params.api; }}
            gridOptions={{
              suppressRowClickSelection: true,
              rowSelection: 'multiple',
            }}
          />
        )}

        {/* ✅ Dropdown */}
        {actionMenu.isOpen && (
          <div
            ref={menuRef}
            style={{
              position: 'fixed',
              top: actionMenu.y,
              left: actionMenu.x,
              background: '#fff',
              border: '1px solid #ddd',
              borderRadius: '6px',
              width: '120px',
              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
              zIndex: 1000
            }}
          >
            <div
              onClick={handleEdit}
              style={{ padding: '10px', cursor: 'pointer' }}
            >
              Edit
            </div>

            <div
              onClick={handleDelete}
              style={{ padding: '10px', cursor: 'pointer', color: 'red' }}
            >
              Delete
            </div>
          </div>
        )}


        <CommonModal
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
            setFormErrors({});
            setTouchedFields({});
          }}
          onSave={handleSave}
          title={modalMode === 'add' ? 'Add New List' : 'Edit List'}
          fields={fields}
          initialData={selectedRow || {}}
          errors={formErrors}
          touched={touchedFields}
          onFieldChange={handleFieldChange}
          onFieldBlur={handleFieldBlur}
          submitText={modalMode === 'add' ? 'Add List' : 'Save Changes'}
          width="500px"
        />

        {showDeleteConfirm && (
          <div
            className="delete-confirmation-overlay"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(0,0,0,0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 1000
            }}
          >
            <div
              className="delete-confirmation-modal"
              style={{
                backgroundColor: 'white',
                padding: '20px',
                borderRadius: '8px',
                maxWidth: '400px',
                width: '90%'
              }}
            >
              <h3 style={{ marginBottom: '15px' }}>Confirm Delete</h3>

              <p style={{ marginBottom: '20px' }}>
                Are you sure you want to delete {selectedCostsToDelete.length} item(s)?
              </p>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'flex-end',
                  gap: '10px'
                }}
              >
                <button
                  className="cancel-delete-btn"
                  onClick={handleCancelDelete}
                  disabled={deleteInProgress}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#f0f0f0',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Cancel
                </button>

                <button
                  className="confirm-delete-btn"
                  onClick={handleConfirmDelete}
                  disabled={deleteInProgress}
                  style={{
                    padding: '8px 16px',
                    backgroundColor: '#dc3545',
                    color: 'white',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: deleteInProgress ? 'not-allowed' : 'pointer'
                  }}
                >
                  {deleteInProgress ? 'Deleting...' : 'Delete'}
                </button>
              </div>
            </div>
          </div>
        )}
      </div>

      {successMessage && (
        <SuccessMessage
          message={successMessage}
          onClose={() => setSuccessMessage('')}
        />
      )}

      {/* 🔽 NEW: warning popup for duplicate list name (client-side or backend 400) */}
      {errorPopupMessage && (
        <SuccessMessage
          message={errorPopupMessage}
          type="error"
          onClose={() => setErrorPopupMessage('')}
        />
      )}
    </>
  );
};

export default ListNameMaintenance;
